import Forbidden from '../../../base/pages/errorPages/Forbidden';

const forbidden: Forbidden = {
  title: 'Forbidden access',
  subtitle: 'You are not authorized to view this page.',
  quip: 'Leave now and Radek will not know.'
};

export default forbidden;
